import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch, { type SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

export interface SwitchProps extends Omit<MuiSwitchProps, 'onChange'> {
  /** react-toolbox: label text */
  label?: React.ReactNode;
  /** react-toolbox: callback with checked value when changed */
  onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Switch wrapper - maps react-toolbox Switch to MUI Switch
 * - `onChange(checked)` transformed from MUI's `onChange(event)`
 * - `label` wraps Switch in FormControlLabel
 */
const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(({ label, onChange, ...rest }, ref) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.checked, event);
    }
  };

  const switchElement = <MuiSwitch ref={ref} onChange={handleChange} {...rest} />;

  if (label) {
    return <FormControlLabel control={switchElement} label={label} />;
  }

  return switchElement;
});

Switch.displayName = 'Switch';

export default Switch;
